
import axios from 'axios'

export const viewEditFileMixin = {
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  data(){
    return {
      type: '',
      fileUrl: '',
      viewerType: 0,
      docsDialog: false,
      docsEditDialog: false,
      docEditor: {}
    }
  },
  methods:{
    viewFile(url, file, entityTypeId, task) {
      if (file.size === '0 Bytes') {
        return this.notification("Notification", "You can't View this file, please open it for Edit before", "info")
      }
      let win = null
      console.log(file)
      let type = url.split('.').pop().toUpperCase();
        this.fileUrl = url;
        this.type = this.fileUrl.split('.').pop().toUpperCase();
        switch (type) {
          case 'GIF':
          case 'JPG':
          case 'JPEG':
          case 'PNG':
          case 'BMP':
            this.viewerType = 2;
            setTimeout(() => {
              console.log('-----', this.$el);
              const viewer = this.$el.querySelector('.images').$viewer;
              viewer.show()
            }, 300);
            break;
          case 'MOV':
          case 'MP4':
            this.viewerType = 3;
            break;
          case 'WMA':
          case 'MP3':
          case 'WAV':
          case 'OGG':
          case 'M4A':
            this.viewerType = 4;
            break;
          case 'STEP':
          case 'STP':
          case 'IGES':
          case 'IGS':
          case 'BREP':
          case 'STL':
          case 'SAT':
          case 'X_T':
          case 'X_B':
          case 'SLDPRT':
          case 'DWG':
          case 'DXF':
          case 'DWF':
          case 'HPGL':
          case 'PLT':
          case 'CGM':
          case 'SVG':
          case 'EMF':
          case 'WMF':
            this.fileUrl = 'https://sharecad.org/cadframe/load?url=' + this.fileUrl;
            setTimeout(() => {
              window.open(this.fileUrl);
            }, 300);
            break;
          case 'PDF':
            window.open(this.fileUrl);
            break;
          case 'DOC':
          case 'DOCM':
          case 'DOCX':
          case 'DOT':
          case 'DOTM':
          case 'DOTX':
          case 'EPUD':
          case 'FODT':
          case 'HTM':
          case 'MHT':
          case 'ODT':
          case 'OTT':
          case 'RTF':
          case 'TXT':
          case 'DJVU':
          case 'XPS':
          case 'CSV':
          case 'FODS':
          case 'ODS':
          case 'OTS':
          case 'XLS':
          case 'XLSM':
          case 'XLSX':
          case 'XLT':
          case 'XLTM':
          case 'XLTX':
          case 'FODP':
          case 'ODP':
          case 'OTP':
          case 'POT':
          case 'POTM':
          case 'POTX':
          case 'PPS':
          case 'PPT':
          case 'PPTM':
          case 'PPTX':
            win = window.open(`https://view.officeapps.live.com/op/view.aspx?src=${file.url}`, '_blank');
            win.focus();
            // this.docsDialog = true;
            //
            // setTimeout(() => {
            //   this.docEditor = new window.DocsAPI.DocEditor("placeholder-1", {
            //     "document": {
            //       "fileType": this.type.toLowerCase(),
            //       "key": `${this.$route.query.companyId}-${file.fileId}`,
            //       "permissions": {
            //         "comment": false,
            //         "copy": false,
            //         "download": false,
            //         "edit": false,
            //         "fillForms": false,
            //         "modifyContentControl": false,
            //         "modifyFilter": false,
            //         "print": false,
            //         "review": false
            //       },
            //       "title": file.name,
            //       "url": file.url
            //     },
            //     "documentType": this.setDocumentType(type),
            //     "editorConfig": {
            //       "user": {
            //         "id": this.user.user.id,
            //         "name": file.user,
            //         "mode": "view"
            //       }
            //     }
            //   });
            // }, 500);
            break;
          default:
            this.$message({
              type: 'info',
              message: this.$t('general_fileFormatIsNotSupported')
            });
            this.fileUrl = '';
            this.type = ''
        }

        // TODO check if in file tab
        if (!file) return
        // TODO Record or not history
        if (entityTypeId == -1) return

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/history/create`, {
            companyId: this.$route.query.companyId,
            entityTypeId: entityTypeId,
            entityId: this.$route.query.projectId || this.$route.query.engagementId || this.$route.query.businessUnitId || this.$route.query.companyVendorId,
            taskId: task ? this.$route.query.taskId : null,
            logAction: 'view',
            logType: 'File',
            fileParams: {
              id: file.fileServiceId,
              pathToDownload: file.url,
              originalName: file.name,
              createdDate: file.date,
              allFileId: file.id,
            }
          })
          .then(response => {
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          })
    },
    editCreatedFile(url, file, mainType, parentId, taskId) {
      console.log('file', file)
      console.log('url', url)
      this.newFileList.forEach((val, index) => {
        console.log('----', file.pathToDownload === val.url)
        if (file.pathToDownload === val.url) val.isEditNow = true;
      });
      // return console.log(url, file, mainType, parentId, taskId);
      let type = url.split('.').pop().toUpperCase();
      this.fileUrl = url;
      this.type = this.fileUrl.split('.').pop().toUpperCase();
      this.docsEditDialog = true;

      setTimeout(() => {
        this.docEditor = new window.DocsAPI.DocEditor("placeholder-2", {
          "document": {
            "fileType": this.type.toLowerCase(),
            "key": `${Date.now()}`,
            "permissions": {
              "comment": true,
              "copy": true,
              "download": true,
              "edit": true,
              "fillForms": true,
              "modifyContentControl": true,
              "modifyFilter": true,
              "print": true,
              "review": true
            },
            "title": file.baseName,
            "url": url
          },
          "documentType": this.setDocumentType(type),
          "editorConfig": {
            "callbackUrl": `${process.env.VUE_APP_DOMAIN_API}/entityFiles/onlyOfficeCallBackHandler?companyId=${this.$route.query.companyId}&fileId=${file.allFileId}`,
            "user": {
              "id": `${this.user.user.id}`,
              "name": `${this.user.user.firstname} ${this.user.user.lastname}`,
              "mode": "edit"
            }
          }
        });
      }, 500);
      let loader = this.$loading.show();
      setTimeout(() => {
        loader.hide()
      }, 5000)
    },
    async checkStatus(file) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const { data } = await axios.get(`/api/v1/entityFiles/checkUserCount?companyId=${this.$route.query.companyId}`)
      return data.success
    },
    async editFile(url, file, mainType, parentId, taskId) {
      const status = await this.checkStatus(file)
      if (!status) {
        return this.notification("Notification", 'To have the ability for parallel creation and editing of office documents, purchase the appropriate subscription.', "info")
      }
      this.newFileList.forEach((val) => {
        if (file.id === val.id) val.isEditNow = true;
        // if (val.children.length) {
        //   val.children.forEach(bal => {
        //     if (file.id === bal.id) {
        //       bal.isEditNow = true;
        //     }
        //   })
        // }
      });
      // return console.log(url, file, mainType, parentId, taskId);
      let type = url.split('.').pop().toUpperCase();
      this.fileUrl = url;
      this.type = this.fileUrl.split('.').pop().toUpperCase();
      this.docsEditDialog = true;
      // console.log('file', file)
      // console.log('url', url)
      // console.log('this.fileUrl', this.fileUrl)
      // console.log('this.type', this.type)
      setTimeout(() => {
        this.docEditor = new window.DocsAPI.DocEditor("placeholder-2", {
          "document": {
            "fileType": this.type.toLowerCase(),
            "key": `${Date.now()}`,
            "permissions": {
              "comment": true,
              "copy": true,
              "download": true,
              "edit": true,
              "fillForms": true,
              "modifyContentControl": true,
              "modifyFilter": true,
              "print": true,
              "review": true
            },
            "title": file.baseName,
            "url": url
          },
          "documentType": this.setDocumentType(type),
          "editorConfig": {
            "callbackUrl": `${process.env.VUE_APP_DOMAIN_API}/entityFiles/onlyOfficeCallBackEditHandler?companyId=${this.$route.query.companyId}&fileId=${file.id}`,
            "user": {
              "id": `${this.user.user.id}`,
              "name": file.user,
              "mode": "edit"
            }
          }
        });
      }, 500);

      let loader = this.$loading.show();
      setTimeout(() => {
        loader.hide()
      }, 5000)
    },
    setDocumentType(type){
      switch (type){
        case 'DOC':
        case 'DOCM':
        case 'DOCX':
        case 'DOT':
        case 'DOTM':
        case 'DOTX':
        case 'EPUD':
        case 'FODT':
        case 'HTM':
        case 'MHT':
        case 'ODT':
        case 'OTT':
        case 'PDF':
        case 'RTF':
        case 'TXT':
        case 'DJVU':
        case 'XPS':
          return 'word';
        case 'CSV':
        case 'FODS':
        case 'ODS':
        case 'OTS':
        case 'XLS':
        case 'XLSM':
        case 'XLSX':
        case 'XLT':
        case 'XLTM':
        case 'XLTX':
          return 'cell';
        case 'FODP':
        case 'ODP':
        case 'OTP':
        case 'POT':
        case 'POTM':
        case 'POTX':
        case 'PPS':
        case 'PPT':
        case 'PPTM':
        case 'PPTX':
          return 'slide';
      }
    },
    ifCanEdit(url){
      let type = url.split('.').pop().toUpperCase();
      switch (type) {
        case 'DOC':
        case 'DOCM':
        case 'DOCX':
        case 'DOT':
        case 'DOTM':
        case 'DOTX':
        case 'EPUD':
        case 'FODT':
        case 'HTM':
        case 'MHT':
        case 'ODT':
        case 'OTT':
        case 'PDF':
        case 'RTF':
        case 'TXT':
        case 'DJVU':
        case 'XPS':
        case 'CSV':
        case 'FODS':
        case 'ODS':
        case 'OTS':
        case 'XLS':
        case 'XLSM':
        case 'XLSX':
        case 'XLT':
        case 'XLTM':
        case 'XLTX':
        case 'FODP':
        case 'ODP':
        case 'OTP':
        case 'POT':
        case 'POTM':
        case 'POTX':
        case 'PPS':
        case 'PPT':
        case 'PPTM':
        case 'PPTX':
          return true;
        default:
          return false
      }
    },
    movChecker(file) {
      if (file) {
        let type = file.name.split('.').pop().toUpperCase();
        console.log(type);
        return type === 'MOV'
      }
      return 'cancel'
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  }
};
